'use client'

import { useLocale } from 'next-intl'
import { usePathname } from 'next/navigation'
import type { Locale } from './config'
import { resolvePathname } from './localized-pathname'

// Ersatz fuer usePathname aus @/i18n/routing ueberall dort, wo der Pfad in den
// gerenderten Inhalt eingeht. next-intl loest beim Vorrendern englischer Seiten
// mit uebersetztem Slug falsch auf: Aus /en/kontakt wird /[slug], weil die
// Catch-all-Route vor dem deutschen Pfad passt. Im Browser kommt /kontakt.
// Was davon abhing, wich zwischen HTML und Browser ab: React #418 auf
// /en/contact, kein aktiver Menuepunkt im HTML von /en/free-consultation.
// Liefert den konkreten internen Pfad (/projekte/wellwood, nicht das Template).
export const useInternalPathname = () => resolvePathname(usePathname(), useLocale() as Locale).internal
